

const Footer = () => {
    return (
        <footer className="sticky-footer bg-white">
            <div className="container my-auto">
                <div className="copyright text-center my-auto">
                    <span>Created by: ENS Enterprises</span>
                </div>
            </div>
        </footer>
    )
}
    
export default Footer;
